module.exports = __webpack_public_path__ + "img/full-tectonic-plates.82043127.svg";